import { UntypedFormControl } from '@angular/forms';

export function DontMatchOtherValidator(otherControlName: string): any {
  let thisControl: UntypedFormControl;
  let otherControl: UntypedFormControl;

  return function dontMatchOtherValidate(control: UntypedFormControl): any {
    if (!control.parent) {
      return undefined;
    }

    if (!thisControl) {
      thisControl = control;
      otherControl = control.parent.get(otherControlName) as UntypedFormControl;
      if (!otherControl) {
        throw new Error('dontMatchOtherValidator(): other control is not found in parent group');
      }
      otherControl.valueChanges.subscribe(() => thisControl.updateValueAndValidity());
    }

    if (!otherControl) {
      return undefined;
    }

    if (otherControl.value === thisControl.value) {
      return {
        dontMatchOther: true,
      };
    }

    return undefined;
  };
}
